import { Input, IconButton, Button, SelectPicker } from "../../";
import { FaSearch } from "react-icons/fa";
import { useMemo, useState, useCallback } from "react";

export default function SearchForm({
  searchTerm,
  onSearchTermChange,
  onKeyDown,
  onSearch,
  loading,
  onOpenDefaultModal,
  onOpenIgnoreModal,
  onOpenChangeExportTypeModal,
  ignoreReasons,
  fileTypes,
  hideAlternativeActions = false,
  showNotInCmsOption = false,
  onNotInCmsSelect,
}) {
  
  const [selectedAction, setSelectedAction] = useState(null);
  
  const alternativeActionsData = useMemo(() => {
    const actions = [
      {
        label: "Link To Default Account",
        value: "default",
        action: onOpenDefaultModal
      }
    ];

    if (ignoreReasons && ignoreReasons.length > 0) {
      actions.push({
        label: "Ignore Transaction",
        value: "ignore", 
        action: onOpenIgnoreModal
      });
    }

    if (fileTypes && fileTypes.length > 0) {
      actions.push({
        label: "Change Export Type",
        value: "export",
        action: onOpenChangeExportTypeModal
      });
    }

    return actions;
  }, [ignoreReasons, fileTypes, onOpenDefaultModal, onOpenIgnoreModal, onOpenChangeExportTypeModal]);

  const handleActionSelect = useCallback((selectedOption) => {
    if (!selectedOption) return;
    if (selectedOption.action) {
      selectedOption.action();
    }
    // Clear selection so placeholder displays again
    setSelectedAction(null);
  }, []);

  return (
    <div className="search-section-horizontal">
      <div className="search-group-left">
        <label className="search-label">Search by Details:</label>
        <div className="search-input-row">
          <Input
            autoFocus
            placeholder="Child name, centre, etc..."
            value={searchTerm || ""}
            onChange={(e) => onSearchTermChange(e.target?.value || "")}
            onKeyDown={onKeyDown}
            data-testid="search-term-input"
            style={{ width: 450}}
          />
          <IconButton
            icon={<FaSearch />}
            appearance="primary"
            onClick={onSearch}
            disabled={!searchTerm.trim() || loading}
            className="search-button-inline"
            data-testid="search-children-btn"
          >
            {loading ? "Searching..." : "Search"}
          </IconButton>
        </div>
      </div>
      
      {showNotInCmsOption && (
        <>
          <div className="divider-vertical">
            <span className="divider-label">OR</span>
          </div>
          
          <div className="not-in-cms-section">
            <Button
              text="Child Not in CMS"
              appearance="subtle"
              width={250}              
              onClick={onNotInCmsSelect}
              data-testid="not-in-cms-button"
            />
          </div>
        </>
      )}
      
      {!hideAlternativeActions && (
        <>
          <div className="divider-vertical">
            <span className="divider-label">OR</span>
          </div>
          
          <div className="alternative-actions">
            <label className="alternative-label">Choose Alternative Action:</label>
            {/* Wrap the SelectPicker in a dedicated container with the test id so tests can reliably locate and interact with it */}
            {/* Forward mouseDown events to the internal react-select control so tests can open the menu by mousing down the wrapper */}
            <div data-testid="alternative-actions-select" aria-label="alternative-actions-select-wrapper">
              <SelectPicker
                data={alternativeActionsData}
                valueKey="value"
                labelKey="label"
                value={selectedAction}
                onChange={handleActionSelect}
                placeholder="Select an action..."
                style={{ width: 540 }}
                cleanable={false}
                menuPosition="static"
                menuPlacement="bottom"
                data-testid="alternative-actions-picker"
                isSearchable={false}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}